/**
 * @owner @Appboy/whats-app
 * WhatsApp List Schema
 *
 * Shared schema for list-message layout structure.
 */

import { z } from "zod";

export const whatsAppListSchema = z
  .object({
    list_button_text: z.string().nullable(),
    list_sections: z.array(
      z.object({
        // A single-section list may be untitled: the composer posts an empty title as undefined, and
        // ListSection only validates presence for multi-section lists
        section_title: z.string().nullable().optional(),
        list_rows: z.array(
          z.object({
            row_title: z.string(),
            row_description: z.string().nullable().optional(),
          })
        ),
      })
    ),
  })
  .nullable()
  .optional();
